export default __webpack_public_path__ + "static/media/stunningcharge.79ffc5e4.png";